import { Grid } from '@material-ui/core';
import React from 'react';

const PageContent = props => <Grid item sm={11} {...props} />;

export default PageContent;
